/*
 * Copyright (c) Kalaora 2022.
 * Author: fharold
 *
 * karevi
 * ProfileForm.ts
 */

import {Type} from "../../../tools/view/form/FormInput";
import Translation from "../../../services/translation/Translation";
import {AbstractForm} from "../../../tools/model/form/AbstractForm";
import {SelectField} from "../../../tools/model/form/SelectField";
import Catalog from "../../Catalog";
import {VideoCatalogSelectDTO} from "../../dto/video/VideoCatalogSelectDTO";
import CatalogService from "../../../services/CatalogService";
import ServiceRepository from "../../../tools/service/ServiceRepository";

export default class VideoCatalogSelectForm extends AbstractForm<VideoCatalogSelectDTO> {
    /*
    TODO : prendre tous les catalogues et regarder si la vidéo de la page courante est présente dedans.
     */

   private _catalogs: Array<Catalog> = [];
    private _currentVideoId: string;
    private _catalogService: CatalogService;

    constructor(catalogs: Catalog[], currentVideoId: string, svcRep: ServiceRepository) {
        super();

        this._currentVideoId = currentVideoId;
        this._catalogService = svcRep.resolve(CatalogService.id) as CatalogService;

        try {
            this._initFields();
        } catch (e) {
            console.error(e);
        }
    }

    private _initFields = async () => {
        this._catalogs = await this._catalogService.findAll();

        this.fields.set(VideoCatalogSelectDTO.CATALOGS, new SelectField<Catalog>(
            this._catalogs.map(catalog => {
                return {
                    value: catalog,
                    name: catalog.title
                }
            }),
            VideoCatalogSelectDTO.CATALOGS,
            (t: Translation) => t.assignedCatalog,
            () => true,
            Type.SELECT,
            true,
            true,
            this._catalogs.filter(catalog => catalog.videos.includes(this._currentVideoId)),
            undefined,
            false,
            (t: Translation) => t.emptyVideoList
        ));
    }

    loadCatalogs(catalogs: Catalog[]) {
        let select: SelectField<Catalog> = this.fields.get(VideoCatalogSelectDTO.CATALOGS) as SelectField<Catalog>;
        if (select) {
            select.options = catalogs.map(catalog => {
                return {
                    value: catalog,
                    name: catalog.title
                };
            })

            this._notifyListener();
        }
    }

    public getCatalogsWhereVideoNeedToBeAdded = (): Array<string> => {
        const field = this.fields.get(VideoCatalogSelectDTO.CATALOGS) as SelectField<Catalog>;
        return (field.value as Array<Catalog>).map(catalog => catalog.id);
    }

    public getCatalogsWhereVideoNeedToBeRemoved = (): Array<string> => {
        const field = this.fields.get(VideoCatalogSelectDTO.CATALOGS) as SelectField<Catalog>;
        const filteredArray = this._catalogs.filter(catalog => {
            const fieldValue = field.value as Array<Catalog>;
            return !fieldValue.find((v) => v.id === catalog.id);
        })

        return filteredArray.map(catalog => catalog.id);
    }

    load(dto: VideoCatalogSelectDTO) {
        super.load(dto);
        console.log("load override");
        let field = this.fields.get(VideoCatalogSelectDTO.CATALOGS)
        console.log("load override", field);
        if (field) field.value = dto.catalogs
    }
}
